import { render, staticRenderFns } from "./listDesc.vue?vue&type=template&id=373b824f&scoped=true&"
import script from "./listDesc.vue?vue&type=script&lang=js&"
export * from "./listDesc.vue?vue&type=script&lang=js&"
import style0 from "./listDesc.vue?vue&type=style&index=0&id=373b824f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373b824f",
  null
  
)

export default component.exports